<template>
    <section class="quicktrial__wrapper">
        <!-- Landing Side -->
        <article class="quicktrial__inner onboarding-quicktrial__informations">
            <header class="onboarding-quicktrial__informations-header">
                <SaasIcon
                    icon="svgLogoSellsyText"
                    :width="isDesktop ? 118 : 168"
                    :height="isDesktop ? 28 : 40"
                    class="onboarding-quicktrial__informations-header-logo"
                />
                <CompassBackForwardButton
                    :label="$t.__('common.labels.back_to_sellsy_website')"
                    link="https://go.sellsy.com"
                    type="secondary"
                    size="small"
                    back
                />
            </header>
            <slot name="banner"></slot>
        </article>

        <!-- Form Side -->
        <article class="quicktrial__inner">
            <slot></slot>
        </article>
    </section>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
    },
    props: {
        isDesktop: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.page-onboarding-trial-quick .global {
    overflow: hidden;
}

.quicktrial__wrapper {
    margin: -32px -32px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100vh;

    @media screen and (max-width: 1023px) {
        flex-direction: column;
        flex-wrap: nowrap;
    }
}

.onboarding-quicktrial__informations {
    &-header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-0);

        &-logo {
            color: var(--colors-common-text-brand-secondary-blue);

            @media screen and (max-width: 1023px) {
                margin: auto;
            }
        }
    }
}

.quicktrial__inner {
    padding: var(--spacing-6);
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 1023px) {
        height: auto;
    }

    &:first-child {
        max-width: 580px;
        gap: var(--spacing-2);
        background-color: var(--colors-common-background-app);
        flex-direction: column;
        justify-content: flex-start;
        flex-wrap: nowrap;

        @media screen and (max-width: 1023px) {
            background-color: transparent;
            padding-bottom: 20px;
            margin: auto;
        }
    }

    &:last-child {
        overflow-y: scroll;
        padding-top: 84px;
        align-items: center;
        width: calc(100% - 580px);

        @media screen and (max-width: 1023px) {
            width: 100%;
            padding-top: 20px;
            overflow-y: unset;
        }
    }
}

.quicktrial__wrapper {
    :deep() {
        .el-form-item.is-error {
            margin-bottom: var(--spacing-3);
        }

        .el-form-item__error {
            margin-left: 0;
        }
    }
}
</style>

<style lang="scss">
.page-onboarding-trial-quick {
    #sellsy_app {
        min-width: auto !important;
    }

    .el-select-dropdown {
        &__wrap {
            padding: var(--spacing-1);
        }

        &__item {
            border-radius: 4px;
            padding: 10px var(--spacing-1);
            line-height: var(--line-heights-20);
        }
    }
}
</style>
